export { default } from './RateCarSuccessPage';
